import './styles/app.css'
import 'vuetify/styles'
export const app = {
  mounted() {
    this.$nextTick(() => {
      // add cookie bar here
      window.addEventListener('scroll', this.onScroll);
    });
  },
  components: {

  },
  data() {
    return {
      menu: false,
      offsetTop: 0,
    };
  },
  methods: {
    toggleMainMenu() {
      this.menu = !this.menu
    },
    onScroll() {
      this.offsetTop = window.scrollY
    },
  },
}
